export const points10 = '12px'; // '13.333333px';
export const points12 = '14px'; // '15.937767px';
export const points14 = '16px'; // '18.594061px';
export const points15 = '17px'; // '19.922208px';

